module.exports = "/packs/course-small-camera-e6f304515c882fd717883e477aa756c3.png";